// extracted by mini-css-extract-plugin
export default {"Product_specifications_container":"ProductInfoFooter_Product_specifications_container__St-8E"};